import type { PackageManager } from '@cli-types/core-engine/utils.js'
import { packageNameFromSpec } from '@next-adapter/package-json/package-name-from-spec.js'

export function buildRemoveArgs(pm: PackageManager, deps: string[], dev: boolean): string[] {
  const devFlag = dev ? (pm === 'yarn' ? '--dev' : '-D') : ''
  const packageNames = deps.map(packageNameFromSpec)

  switch (pm) {
    case 'pnpm':
      return ['remove', ...(devFlag ? [devFlag] : []), ...packageNames]
    case 'yarn':
      return ['remove', ...(devFlag ? [devFlag] : []), ...packageNames]
    case 'bun':
      return ['remove', ...(devFlag ? [devFlag] : []), ...packageNames]
    default:
      return ['uninstall', ...(devFlag ? [devFlag] : []), ...packageNames]
  }
}
